var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "boolean-field", class: _vm.classes }, [
    _c(
      "div",
      {
        staticClass:
          "input-group inline-flex items-center flex-wrap spacer-x-3 spacer-y-2",
      },
      [
        _c("label", { staticClass: "w-full" }, [_vm._v(_vm._s(_vm.label))]),
        _vm._v(" "),
        _c(
          "div",
          [
            !_vm.editing || !_vm.editable
              ? _c(
                  "span",
                  { style: _vm.localField ? "color: #6aca8a" : "#F0766E" },
                  [_vm._v(_vm._s(_vm.localField ? "YES" : "NO"))]
                )
              : _c("toggle-button", {
                  attrs: {
                    sync: true,
                    labels: { checked: "YES", unchecked: "NO" },
                    color: { checked: _vm.$brandPrimary, unchecked: "#b7b7b7" },
                  },
                  model: {
                    value: _vm.localField,
                    callback: function ($$v) {
                      _vm.localField = $$v
                    },
                    expression: "localField",
                  },
                }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }